import { styled } from "@mui/material";
import { Link, NavLink } from "react-router-dom";

export const Section = styled('div')(({ theme }) => (props) => ({
    padding: '48px  96px',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px',
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px ',
        flexDirection: 'column'
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px',
    }
}))
export const HeadSection = styled(NavLink)(({ theme }) => (props) => ({
    fontSize: props.first ? "16px" : '1.8vw',
    fontWeight: props.first ? 500 : 800,
    lineHeight: '29px',
    letterSpacing: '0em',
    display: 'inline',
    margin: '0 10px',
    textDecoration: 'none',
    color: props.first ? "gray" :
        theme.palette.mode === 'light' ?
            theme.palette.text.lightSecondary :
            theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '2vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2.2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '20px',
    },
}))
export const RightSection = styled('div')(({ theme }) => (props) => ({
    width: '50%',
    [theme.breakpoints.down("sm")]: {
        width: '100%'
    }

}))
export const LeftSection = styled('div')(({ theme }) => (props) => ({
    width: '50%',
    paddingLeft: '48px',
    borderLeft: "solid 1px #BDBDBD",
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    [theme.breakpoints.down("sm")]: {
        width: '100%',
        paddingLeft: '12px',
        borderLeft: "none",

    }

}))
export const HeadSub = styled(Link)(({ theme }) => (props) => ({
    fontSize: '1.2vw',
    fontWeight: 600,
    letterSpacing: '0em',
    display: 'inline',
    margin: '-2px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    textDecoration: 'none',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.7vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '1.9vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
    }
}))
export const ImageSub = styled('div')(({ theme }) => (props) => ({
    width: '48px',
    height: '48px',

}))
export const Image = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: theme.shape.borderRadius
}))
export const TextDiscretion = styled('p')(({ theme }) => (props) => ({
    fontSize: '1vw',
    fontWeight: '400',
    display: 'block',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.3vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        fontWeight: '600'
    }
}))
export const TextHead = styled('p')(({ theme }) => (props) => ({
    fontSize: '20px',
    fontWeight: '700',
    display: 'block',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.5vw'
    },
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.6vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
        fontWeight: '600'
    }
}))
export const SubComp = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    justifyContent:'space-between',
    padding:'0 20px'

}))
export const SubCompContent = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
}))
export const TextComp = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0'
}))

export const TextPay = styled('p')(({ theme }) => (props) => ({
    fontSize: '14px',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
    flexWrap: "wrap",
    width: '80%',
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.2vw'
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '1.3vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
    }
}))

